<template>
  <div class="input-dropdown" :class="{'active': isDropdropVisible}">
    <div class="input-dropdown__selection">
      <div class="input-dropdown__button-wrapper">
        <button
          class="touch"
          :class="{
            'active': value !== '',
            'invert' : isDropdropVisible
          }"
          @click="isDropdropVisible = !isDropdropVisible"
        >
          {{ value ? value : 'Any' }}
        </button>
      </div>
    </div>
    <transition name="fast-fade">
      <div v-if="isDropdropVisible" class="input-dropdown__buttons">
        <transition-group
          appear
          :css="false"
          @before-enter="beforeEnter"
          @enter="enter"
          @leave="leave"
        >
          <div 
            class="input-dropdown__button-wrapper"
            v-for="(selection, i) in selections"
            :key="selection.value"
            :data-index="i"
            @click="emitSelection(selection.value)"
          >
            <button class="touch" :class="{ 'active': selection.value === value }">{{ selection.label }}</button>
          </div>
        </transition-group>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  props: ['icon', 'selections', 'value'],

  data () {
    return {
      isDropdropVisible: false
    }
  },

  methods: {
    emitSelection (value) {
      this.isDropdropVisible = false

      if (this.value === value) {
        this.$emit('input', '')
      } else {
        this.$emit('input', value)
      }
    },

    beforeEnter: function (el) {
      el.style.opacity = 0
      el.style.transform = 'translateY(-.25rem)'
    },

    enter: function (el, done) {
      var delay = el.dataset.index * 50
      setTimeout(function () {
        el.style.opacity = 1
        el.style.transform = 'translateY(0)'
      }, delay)
    },

    leave: function (el, done) {
      var delay = el.dataset.index * 50
      setTimeout(function () {
        el.style.opacity = 0
        el.style.transform = 'translateY(-.25rem)'
      }, delay)
    }
  }
}
</script>
<style lang="scss" scoped>
@import "@/styles/_variables.scss";

.input-dropdown {
  align-items: center;
  display: flex;
  justify-content: flex-start;
  position: relative;
  width: 15rem;

  &__selection {
    border: none;
    border-radius: .5rem;
    display: flex;
    flex-wrap: wrap;
    margin: 0 -.2rem;
    z-index: 7;

    .active & {
      z-index: 9;
    }

    button {
      border: 0.1rem solid $white;
      color: $white;
    
      &.active {
        background: $darklime;
      }

      &.invert {
        background: $white;
        border: 0.1rem solid #333;
        color: #333;

        &.active {
          background: $lime;
        }
      }
    }
  }

  &__buttons {
    background: rgba(255, 255, 255, 0.95);
    border: none;
    border-radius: .5rem;
    display: flex;
    flex-wrap: wrap;
    margin: 0 -.2rem;
    max-height: 38rem;
    overflow: auto;
    padding: 4rem 0 0;
    pointer-events: all;
    position: absolute;
    top: 0;
    z-index: 6;

    .active & {
      z-index: 8;
    }

    button {
      border: 0.1rem solid #333;
      color: #333;
    
      &.active {
        background: $lime;
      }
    }
  }

  &__button-wrapper {
    height: 3rem;
    padding: 0.2rem;
    transition: all 200ms cubic-bezier(0.645, 0.045, 0.355, 1);
    width: 19.5rem;
  }

  button {
    align-items: center;
    background: transparent;
    border-radius: .5rem;
    display: flex;
    font-size: 1rem;
    font-weight: 100;
    justify-content: center;
    height: 100%;
    line-height: 1;
    padding-top: .15rem;
    text-transform: uppercase;
    transition: all 150ms ease-out;
    width: 100%;
  }
}
</style>

